import React from "react";
import { KTIcon, toAbsoluteUrl } from "../../../../_metronic/helpers";
import { Tables } from "../../../modules/widgets/components/Tables";

type Props = {
  className: string;
};

const TableCustomer: React.FC<Props> = ({ className }) => {
  const data = [
    {
      customer_name: "AJINOMOTO",
      customer_id: "02289218",
      maximum_contract: "205,222 MMBtu/month",
      est_end_volume: "109,210 MMBtu",
      total_usage: "129,990",
      price: "Rp19.000.000",
    },
    {
      customer_name: "MITSUBISHI",
      customer_id: "02289277",
      maximum_contract: "250,222 MMBtu/month",
      est_end_volume: "289,210 MMBtu",
      total_usage: "300,000",
      price: "Rp28.000.000",
    },
    {
      customer_name: "SASA",
      customer_id: "02289238",
      maximum_contract: "200,222 MMBtu/month",
      est_end_volume: "220,210 MMBtu",
      total_usage: "190,990",
      price: "Rp18.000.000",
    },
    {
      customer_name: "MASAKO",
      customer_id: "02289270",
      maximum_contract: "200,222 MMBtu/month",
      est_end_volume: "189,210 MMBtu",
      total_usage: "120,990",
      price: "Rp19.000.000",
    },
    {
      customer_name: "SAMSUNG",
      customer_id: "02289818",
      maximum_contract: "200,222 MMBtu/month",
      est_end_volume: "189,210 MMBtu",
      total_usage: "0,990",
      price: "Rp19.000.000",
    },
  ];
  return (
    <>
      <div className={`card ${className}`}>
        {/* begin::Header */}
        <div className="card-header border-0 pt-5">
          <div>
            <div className="card-title align-items-start flex-column">
              <span className="card-label fw-bold fs-5 mb-1">
                Last Update Data
              </span>
            </div>
            <div className="text-muted" style={{ marginTop: "-10px" }}>
              15 Nov 2023 15:19
            </div>
          </div>
          <div className="card-toolbar">
            <ul className="nav">
              <li className="nav-item">
                <a
                  className="nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary active fw-bold px-4 me-1"
                  data-bs-toggle="tab"
                  href="#kt_table_widget_5_tab_1"
                >
                  All
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bold px-4 me-1"
                  data-bs-toggle="tab"
                  href="#kt_table_widget_5_tab_2"
                >
                  Low
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bold px-4"
                  data-bs-toggle="tab"
                  href="#kt_table_widget_5_tab_3"
                >
                  Exceed
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="card-body py-3">
          <div className="table-responsive">
            <table className="table align-middle gs-0 gy-4">
              <thead>
                <tr className="fw-bold text-muted bg-light">
                  <th className="ps-4 min-w-300px rounded-start">
                    Customer Name
                  </th>
                  <th className="min-w-125px rounded-start">Total Usage</th>
                  <th className="min-w-125px">Total Price</th>
                  <th className="min-w-200px text-start">
                    Total Estimation Usage
                  </th>
                  <th className="min-w-125px">Max. Contract</th>
                  <th className=""></th>
                </tr>
              </thead>
              <tbody>
                {data.map((v) => {
                  return (
                    <tr>
                      <td>
                        <div className="d-flex align-items-center">
                          <div className="symbol symbol-50px me-5">
                            <span className="symbol-label bg-light">
                              <img
                                src={toAbsoluteUrl(
                                  "/media/svg/avatars/020-girl-11.svg"
                                )}
                                className="h-75 align-self-end"
                                alt=""
                              />
                            </span>
                          </div>
                          <div className="d-flex justify-content-start flex-column">
                            <a
                              href="#"
                              className="text-dark fw-bold text-hover-primary mb-1 fs-6"
                            >
                              {v.customer_name}
                            </a>
                            <span className="text-muted fw-semibold text-muted d-block fs-7">
                              {v.customer_id}
                            </span>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="d-flex flex-column w-100 me-2">
                          <div className="text-dark fw-bold text-hover-primary d-block mb-2 fs-6">
                            {v.total_usage} MMBtu
                          </div>
                          <div style={{ height: "12px" }}>
                            <div className="progress h-7px w-100">
                              <div
                                className={`progress-bar ${(parseInt(v.total_usage) / 250) * 100 > 100
                                    ? "bg-danger"
                                    : (parseInt(v.total_usage) / 250) * 100 < 25
                                      ? "bg-success"
                                      : "bg-primary"
                                  }`}
                                role="progressbar"
                                style={{
                                  width: `${(
                                    (parseInt(v.total_usage) / 250) *
                                    100
                                  ).toPrecision(1)}%`,
                                }}
                              ></div>
                            </div>
                            <div className="text-muted fw-semibold text-muted d-block fs-8 text-center mt-1">
                              {(parseInt(v.total_usage) / 250) * 100}%
                            </div>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="text-dark fw-bold text-hover-primary d-block  fs-6">
                          {v.price}
                        </div>
                        <span className="text-muted fw-semibold text-muted d-block fs-7">
                          {v.customer_name == "SASA" ||
                            v.customer_name == "MASAKO"
                            ? "Debt"
                            : "Paid"}
                        </span>
                      </td>
                      <td>
                        <span className="text-muted fw-semibold text-muted d-block fs-7">
                          {v.est_end_volume}
                        </span>
                      </td>
                      <td>
                        <span className="text-muted fw-semibold text-muted d-block fs-7">
                          {v.maximum_contract}
                        </span>
                      </td>
                      <td className="text-end">
                        <a
                          href="#"
                          className="btn btn-bg-light btn-color-muted btn-active-color-primary btn-sm px-4 me-2"
                        >
                          View
                        </a>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default TableCustomer;
